import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="remove-fields"
export default class extends Controller {
  static targets = [ "link", 'hiddenField' ]

  remove(event) {
    event.preventDefault()
    // Find the parent wrapper for the set of nested fields.
    let fieldParent = this.linkTarget.closest('.nested-fields')
    
    let deleteField = fieldParent ? this.hiddenFieldTarget : null
    
    // If there is a delete field, update the value to `1` and hide the corresponding nested fields.
    if (deleteField) {
      deleteField.value = 1;
      fieldParent.style.display = 'none';
    }
  }
}
